import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import CloseIcon from "@mui/icons-material/Close";
import FileUpload from "react-drag-n-drop-image";
import { toast } from "react-toastify";
import moment from "moment";

const CustomBody = () => {
  return (
    <div
      className="drag-file-area mt-0"
      style={{
        border: "0px",
        borderRadius: "0px",
        width: "100%",
        position: "relative",
      }}
    >
      <div>
        <CloudDownloadIcon style={{ fontSize: "50px" }} />
      </div>
      <h3 className="dynamic-message" style={{ fontFamily: "Montserrat" }}>
        Drag &amp; drop any file here
      </h3>
      <label className="">
        <span className="">
          <span
            className="browse-files-text"
            style={{
              fontFamily: "Montserrat",
              color: "#539ffe",
            }}
          >
            browse file
          </span>
          <span style={{ fontFamily: "Montserrat" }}>from device</span>
        </span>
      </label>
    </div>
  );
};

function ShowData({ files, onRemoveImage }) {
  return (
    <div className="">
      {files.map((item) => {
        return (
          <>
            <div
              className="drag-file-area mt-0"
              style={{
                border: "0px",
                borderRadius: "0px",
                position: "relative",
              }}
            >
              <div className="d-flex" style={{ justifyContent: "center" }}>
                <div style={{ height: "200px", width: "200px" }} className="">
                  <img
                    src={item.preview}
                    alt="preview..."
                    height="100%"
                    width="100%"
                    style={{ objectFit: "contain" }}
                  />
                </div>
                <CloseIcon
                  style={{
                    cursor: "pointer",
                    color: "red",
                    position: "absolute",
                    right: 10,
                    top: 10,
                  }}
                  // onClick={() => {
                  //   setDragImage2(true);
                  //   setImage2(null);
                  // }}
                  onClick={() => onRemoveImage(item.id)}
                />
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
}

export default function Notice() {
  

  const { showPage, setShowPage, accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [imageFile, setImageFile] = React.useState();
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [showImages, setShowData] = React.useState(false);
  const [isEditDataImage1, setIsEditDataImage1] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const LoginSchema = Yup.object().shape({
    title: Yup.string().required("required"),
    description: Yup.string().required("required"),
    active: Yup.string().required("required"),
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/notice/get-notice`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const IsEditOnRemoveImage = () => {
    setShowData(false);
    console.log("isEditOnRemove::: ");
    setFiles([]);
    setIsEditDataImage1(false);
  };

  const onRemoveImage = (id) => {
    setShowData(false);
    setFiles((prev) => prev.filter((i) => i.id !== id));
  };

  const onError = (error) => {
    console.error(error);
  };

  const onChange = (e) => {
    if (files.length === 0) {
      console.log(e[0].file.name, "true");
      setShowData(true);
      setImageFile(e[0].file);
      setFiles(e);
    }
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    setIsEditDataImage1(true);
    console.log("item edit value :::", item.image);
    console.log("value:::", item);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    console.log("imageFile :::", imageFile);
    setImageFile();
    setIsEditDataImage1(false);
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);
    const body = {
      title: value?.title,
      description: value?.description,
      active: value?.active,
    };

    if (imageFile) {
      let img1FormData = new FormData();
      img1FormData.append("notice-image", imageFile);

      axios(`${API_URL}/api/admin/notice/upload-notice/${rowValue._id}`, {
        method: "POST",
        credentials: "include",
        data: img1FormData,
      })
        .then((result) => {
          if (result.data.status) {
            axios
              .patch(
                `${API_URL}/api/admin/notice/update-notice/${rowValue._id}`,
                body
              )
              .then((res) => {
                if (res.data.status) {
                  successAdd(result.data.message);
                  setbuttonLoader(false);
                  socket.emit("bannerUpdate");
                } else {
                  warningAlert();
                  setbuttonLoader(false);
                }
              })
              .catch((err) => {
                setbuttonLoader(false);
                warningAlert();
              });
          }
        })
        .catch((err) => {
          console.log("handleSubmit err :::", err);
        });
    } else {
      axios
        .patch(
          `${API_URL}/api/admin/notice/update-notice/${rowValue._id}`,
          body
        )
        .then((res) => {
          if (res.data.status) {
            successAdd(res.data.message);
            setbuttonLoader(false);
          } else {
            warningAlert();
            setbuttonLoader(false);
          }
        })
        .catch((err) => {
          setbuttonLoader(false);
          console.log("update err :::", err);
          warningAlert();
        });
    }
  };

  const addNewTournament = (value) => {
    const body = {
      title: value.title,
      description: value.description,
      active: value?.active,
    };

    axios(`${API_URL}/api/admin/notice/add-notice`, {
      method: "POST",
      credentials: "include",
      data: body,
    })
      .then((result) => {
        console.log("result...", result.data);
        if (result.data.status) {
          const formData = new FormData();
          formData.append("notice-image", imageFile);

          axios(
            `${API_URL}/api/admin/notice/upload-notice/${result.data.data._id}`,
            {
              method: "POST",
              credentials: "include",
              data: formData,
            }
          )
            .then((result) => {
              if (result.data.status) {
                setbuttonLoader(false);
                socket.emit("bannerAdd");
                successAdd(result.data.message);
              } else {
                toast.error(result.data.message);
                setbuttonLoader(false);
              }
            })
            .catch((err) => {
              console.log("handleSubmit err :::", err);
            });
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
        warningAlert();
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this notice. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The notice has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);

    axios
      .delete(`${API_URL}/api/admin/notice/delete-notice/${e._id}`)
      .then((res) => {
        console.log(res);
        if (res.data.status) {
          successDeleted();
          socket.emit("bannerDelete");
        }
        getBranch();
      });
  };

  const successAdd = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The notice has been processed successfully."}</p>
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">Something went wrong. Please try again later.</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  description: rowValue ? rowValue?.description : "",
                  title: rowValue ? rowValue?.title : "",
                  active: rowValue ? rowValue?.active : false,
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log("values...", values);
                  console.log("openValue...", openValue);

                  if (openValue === 1) {
                    console.log("update formik value :::", openValue);
                    addNewTournament(values);
                  }
                  if (openValue === 2) {
                    console.log("update formik value :::", openValue);
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, values }) => (
                  <Form>
                    <div className="row">
                      {/* Title Field */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Title <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="title"
                            placeholder="Enter notice title"
                            className={`mt-1 form-control ${touched.title && errors.title ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="title" className="invalid-feedback" />
                        </div>
                      </div>

                      {/* Active Status */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Status <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="active"
                            className={`mt-1 form-control ${touched.active && errors.active ? "is-invalid" : ""}`}
                          >
                            <option value={true}>Active / ON</option>
                            <option value={false}>Inactive / OFF</option>
                          </Field>
                          <ErrorMessage component="div" name="active" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* Description Field */}
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Description <span className="text-danger">*</span></label>
                          <Field
                            as="textarea"
                            name="description"
                            placeholder="Enter full notice description..."
                            rows="3"
                            className={`mt-1 form-control ${touched.description && errors.description ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="description" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <label className="mb-2">Attachment / Image</label>
                        {isEditDataImage1 ? (
                          <div className="file-upload-box border rounded p-3 text-center position-relative" style={{ backgroundColor: "#f8f9fa" }}>
                            <div className="d-inline-block position-relative">
                              <img
                                src={rowValue?.image}
                                alt="preview"
                                style={{ maxHeight: "200px", maxWidth: "100%", objectFit: "contain" }}
                              />
                              <CloseIcon
                                style={{
                                  cursor: "pointer",
                                  color: "white",
                                  backgroundColor: "#dc3545",
                                  borderRadius: "50%",
                                  padding: "2px",
                                  position: "absolute",
                                  right: "-10px",
                                  top: "-10px",
                                  fontSize: "20px"
                                }}
                                onClick={() => IsEditOnRemoveImage()}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="file-upload-box">
                            {showImages ? (
                              <ShowData files={files} onRemoveImage={onRemoveImage} />
                            ) : (
                              <FileUpload
                                onError={onError}
                                body={<CustomBody />}
                                overlap={false}
                                fileValue={files}
                                onChange={(e) => onChange(e)}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="d-flex mt-4 pt-2 border-top">
                      <button
                        style={{ width: "110px" }}
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={buttonLoader}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <b>Submit</b>
                          {buttonLoader && (
                            <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                          )}
                        </div>
                      </button>
                      <button
                        style={{ width: "110px" }}
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ms-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            <div className="row pl-4 pr-4 pt-4">
              <div className="col-12 col-md-5">
                {accessObject?.bannerAdd === true && (
                  <button
                    style={{ width: "118px" }}
                    onClick={() => {
                      openAddTournament(1);
                    }}
                    type="button"
                    className="btn btn-primary btn-block "
                  >
                    <AddIcon />
                    Add New
                  </button>
                )}
              </div>
              <div className="col-12 col-md-7">
                <h3 class="card-title">
                  <b>Notice</b>
                </h3>
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Active</th>
                    {accessObject?.bannerEdit === true && <th>Action</th>}
                  </tr>
                </thead>
                {accessObject?.getBannerList === true ? (
                  <>
                    <tbody>
                      {!loader ? (
                        <>
                          {tableData.length > 0 ? (
                            <>
                              {tableData
                                ?.slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <>
                                    <tr key={index}>
                                      <td>{index + 1 + pagination.start}</td>
                                      <td>
                                        {moment(item.createdAt).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td>{item.title}</td>
                                      <td>{item.description}</td>
                                      <td>{item.active ? "On" : "Off"}</td>
                                      <td className="d-flex justify-content-evenly ">
                                        {accessObject?.bannerEdit === true && (
                                          <EditIcon
                                            className="mr-3 courser"
                                            onClick={() =>
                                              clickEditButton(item)
                                            }
                                          />
                                        )}
                                        {/* {accessObject?.bannerDelete ===
                                          true && (
                                          <ClearIcon
                                            className="courser text-danger"
                                            onClick={() =>
                                              warningWithConfirmMessage(item)
                                            }
                                          />
                                        )} */}
                                      </td>
                                    </tr>
                                  </>
                                ))}
                            </>
                          ) : (
                            <EmptyState colSpan={6} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </>
                ) : (
                  <>
                    <tr
                      style={{ backgroundColor: "rgba(0,0,0,.05)" }}
                      className="text-center"
                    >
                      <td colSpan={4}>
                        <h5>Access Denied</h5>
                      </td>
                    </tr>
                  </>
                )}
              </table>
              {accessObject?.getBannerList === true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getBannerList === true && tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
